import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/features/shared';

import {
  CancelledSigningComponent,
  CompletedSigningComponent,
  EarlySigningComponent,
  ExpiredSigningComponent,
  FurtherAssistanceComponent,
  GenericErrorComponent,
  InvalidLinkComponent,
  InvalidURLComponent,
  KbaFailComponent,
  ProcessingSigningComponent,
  SmartphonesUnsupportedComponent,
  UnauthorizedComponent,
  UnsupportedBrowserComponent,
  UnsupportedDeviceComponent,
  UnsupportedOperatingSystemComponent,
} from './components';
import { FeedbackComponent } from './containers';
import { OptOutComponent } from './components/opt-out/opt-out.component';

@NgModule({
  declarations: [
    CancelledSigningComponent,
    CompletedSigningComponent,
    EarlySigningComponent,
    ExpiredSigningComponent,
    FeedbackComponent,
    FurtherAssistanceComponent,
    InvalidURLComponent,
    ProcessingSigningComponent,
    UnsupportedBrowserComponent,
    UnsupportedDeviceComponent,
    UnauthorizedComponent,
    InvalidLinkComponent,
    GenericErrorComponent,
    KbaFailComponent,
    UnsupportedOperatingSystemComponent,
    SmartphonesUnsupportedComponent,
  ],
  imports: [CommonModule, SharedModule, OptOutComponent],
})
export class FeedbackModule {}
